import './deprecation-workflow';

import Application from '@ember/application';

import compatModules from '@embroider/virtual/compat-modules';
import '@warp-drive/ember/install';
import 'decorator-transforms/globals';
import Resolver from 'ember-resolver';
import loadInitializers from 'ember-load-initializers';

import './style/app.scss';
import ENV from './config/environment';

import stubs from './ssr-stubs';
stubs(compatModules);

export default class App extends Application {
  rootElement = '#rise-app';
  modulePrefix = ENV.modulePrefix;
  podModulePrefix = ENV.podModulePrefix;
  Resolver = Resolver.withModules(compatModules);
}

export function createSsrApp() {
  return App.create(ENV.APP);
}

loadInitializers(App, ENV.modulePrefix, compatModules);
